<template>
  <div>
    <masternav />
    <b-container class="mt-5">
      <br /><br />
      <h1 class="titlequestion ml-5 mr-5 text-center">
       
      </h1>
      <div class="ml-5 mr-5 navtext2 text-center">
        <h5></h5>
      </div>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col lg="12">
                {{ error }}
                <b-alert variant="danger" show v-show="errors.length > 0">
                  <ul>
                    <li v-for="(item, index) in errors" :key="index">
                      {{ item }}
                    </li>
                  </ul>
                </b-alert>
                <b-form @submit.prevent="passwordReset">
                  <b-form-group
                    label="Correo Electrónico"
                    label-for="contrato"
                    description=""
                  >
                    <b-form-input
                      id="contrato"
                      type="email"
                      required
                      placeholder=""
                      v-model="form.email"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Nueva contraseña"
                    label-for="password1"
                    description=""
                  >
                    <b-form-input
                      id="password1"
                      type="password"
                      placeholder=""
                      v-model="form.password"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Confirmar contraseña"
                    label-for="password2"
                    description=""
                  >
                    <b-form-input
                      id="password2"
                      type="password"
                      placeholder=""
                      v-model="form.password_confirmation"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-button type="submit" block squared class="button" :disabled="sending">
                    <span v-if="sending">{{ text1 }}</span>
                    <span v-else>{{ text }}</span>
                    <b-spinner v-show="sending" small label="Small Spinner"></b-spinner>
                    </b-button
                  >
                </b-form>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <br /><br />
    <contactcomp />
    <mainfooter />
  </div>
</template>

<script>
import masternav from "@/components/masternav.vue";
import Mainfooter from "../components/mainfooter.vue";
import Contactcomp from "../components/contactcomp.vue";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: {
    masternav,
    Contactcomp,
    Mainfooter,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        password_confirmation: "",
        token: this.$route.params.token,
      },
      errors: [],
      error: "",
        sending:false,
        text:'Enviar',
        text1:'procesando...'
    };
  },
  mounted () {
      if (!this.modoClientes) 
        {
            this.$router.push('/')
        }
  },
  computed: {
       ...mapState('autenticacion', ['modoClientes'])
  },
  methods: {
    passwordReset() {
        this.sending = !this.sending
      axios
        .post("password/reset", this.form)
        .then((resp) => {
          console.log(resp.data.message);
          this.errors = [];
          this.form = {};
          this.$bvToast.toast(resp.data.message, {
            variant: "success",
            title: false,
            solid: true,
          });
          this.sending = !this.sending
        })
        .catch((e) => {
          this.errors = [];
          if (!!e.response.data.errors) {
            this.errors.push(e.response.data.errors);
          } else {
            this.error = e.response.data.error;
          }
          this.sending = !this.sending
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
